import React from 'react'
import {SectionOne} from './parts/section-one'
const GkGurantee = () => {
  return (
    <div>
      <SectionOne/>
    </div>
  )
}

export default GkGurantee
